import { CommonModule } from '@angular/common';
import {
    TgButtons2Module,
    TgFormsModule,
    TgGridModule,
    TgInputMaskModule,
    TgModalModule,
    TgSpacingModule,
    TgToggleModule
} from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { TmContactModalComponent } from './tm-contact-modal.component';
import { DraftValidationModule } from '@classifieds-sell/shared';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgGridModule,
        TgInputMaskModule,
        TgModalModule,
        TgFormsModule,
        TgSpacingModule,
        TgToggleModule,
        TgButtons2Module,
        LayoutModule,
        DraftValidationModule
    ],
    declarations: [
        TmContactModalComponent
    ],
    exports: [TmContactModalComponent]
})
export class TmContactModalModule {
}
